define('home/templates/completeOnboarding',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"onboard-complete__channel spacing-top\">\n<span data-steps=\""
    + alias2(alias1((depth0 != null ? depth0.steps : depth0), depth0))
    + "\" data-duration=\"550\" class=\"onboard-complete__avatar relative__wrapper inline_block spacing-right\">\n<span class=\"onboard-complete__img\">"
    + ((stack1 = container.invokePartial(partials.channelAvatarWithDefault,(depth0 != null ? depth0.channel : depth0),{"name":"channelAvatarWithDefault","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</span>\n<span class=\"onboard-complete__checkmark icon-checkmark\"></span>\n</span>\n<strong>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.name : stack1), depth0))
    + "</strong>\n</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"spacing-top\">\n"
    + ((stack1 = helpers["if"].call(alias1,helpers.eq.call(alias1,(depth0 != null ? depth0.overflowCount : depth0),1,{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "<strong>… and 1 other</strong>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "<strong>… and "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.overflowCount : depth0), depth0))
    + " others</strong>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"onboard-complete\">\n<span class=\"spinner\"></span>\n\n<section data-steps=\"1\" data-duration=\"700\" class=\"onboard-complete__step text-gray-darker\">\n<strong>"
    + alias2(helpers.gettext.call(alias1,"Building your feed…",{"name":"gettext","hash":{},"data":data}))
    + "</strong>\n</section>\n\n<section data-steps=\""
    + alias2(container.lambda((depth0 != null ? depth0.channelsShownSteps : depth0), depth0))
    + "\" data-role=\"channels\" class=\"onboard-complete__step text-center text-gray-darker\">\n<strong>"
    + alias2(helpers.gettext.call(alias1,"Adding channels you followed…",{"name":"gettext","hash":{},"data":data}))
    + "</strong>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.channels : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.if_all.call(alias1,(depth0 != null ? depth0.overflowCount : depth0),(depth0 != null ? depth0.isEnglish : depth0),{"name":"if_all","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</section>\n</div>\n";
},"usePartial":true,"useData":true})

});
